import {
  ActiveFiltersBar,
  RemovableFilterBadge,
} from "@/components/dashboard/active-filters-bar";
import { cn } from "@/lib/utils";
import type { ColumnFilterBadge } from "./dashboard-column-filter-utils";

interface DashboardColumnFilterBadgesProps {
  badges: ColumnFilterBadge[];
  onClearAll?: () => void;
  onRemove?: (badge: ColumnFilterBadge) => void;
  className?: string;
}

export function DashboardColumnFilterBadges({
  badges,
  onClearAll,
  onRemove,
  className,
}: DashboardColumnFilterBadgesProps) {
  if (badges.length === 0) return null;

  return (
    <ActiveFiltersBar
      appliedCount={badges.length}
      onClearAll={onClearAll}
      className={cn("mb-2", className)}
    >
      {badges.map((badge) => (
        <RemovableFilterBadge
          key={badge.key}
          label={badge.label}
          onRemove={onRemove ? () => onRemove(badge) : undefined}
        />
      ))}
    </ActiveFiltersBar>
  );
}
